/**
 * GDPR-style cookie preferences modal.
 * Granular control: essential (required), analytics, marketing.
 * Link to privacy policy. Accessible.
 */
import React, { useState, useEffect } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  FormControlLabel,
  Switch,
  Box,
} from '@mui/material'
import { useConsent } from '../../contexts/ConsentContext'

const CookiePreferencesModal = ({ open, onClose }) => {
  const { consent, updatePreferences } = useConsent()
  const [analytics, setAnalytics] = useState(false)
  const [marketing, setMarketing] = useState(false)

  useEffect(() => {
    if (open) {
      setAnalytics(consent.analytics)
      setMarketing(consent.marketing)
    }
  }, [open, consent.analytics, consent.marketing])

  const handleSave = () => {
    updatePreferences({ analytics, marketing })
    onClose()
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="cookie-prefs-title"
      aria-describedby="cookie-prefs-desc"
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: { borderRadius: 2 },
      }}
    >
      <DialogTitle id="cookie-prefs-title">
        Preferenze Cookie
      </DialogTitle>
      <DialogContent dividers>
        <Typography id="cookie-prefs-desc" variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Puoi scegliere quali categorie di cookie consentire. I cookie essenziali sono necessari
          per il funzionamento dell&apos;applicazione e non possono essere disattivati.
        </Typography>

        <Box sx={{ mb: 2 }}>
          <FormControlLabel
            control={<Switch checked disabled />}
            label="Cookie essenziali (richiesti)"
          />
          <Typography variant="caption" display="block" color="text.secondary" sx={{ ml: 4 }}>
            Necessari per autenticazione, preferenze e funzionalità base.
          </Typography>
        </Box>

        <Box sx={{ mb: 2 }}>
          <FormControlLabel
            control={
              <Switch
                checked={analytics}
                onChange={(e) => setAnalytics(e.target.checked)}
                color="primary"
              />
            }
            label="Cookie analitici"
          />
          <Typography variant="caption" display="block" color="text.secondary" sx={{ ml: 4 }}>
            Ci aiutano a capire come viene utilizzata l&apos;app per migliorarla.
          </Typography>
        </Box>

        <Box sx={{ mb: 2 }}>
          <FormControlLabel
            control={
              <Switch
                checked={marketing}
                onChange={(e) => setMarketing(e.target.checked)}
                color="primary"
              />
            }
            label="Cookie marketing / tracciamento"
          />
          <Typography variant="caption" display="block" color="text.secondary" sx={{ ml: 4 }}>
            Attualmente non utilizzati. Disponibili per future funzionalità.
          </Typography>
        </Box>

        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          Per maggiori informazioni, consulta la{' '}
          <a href="/privacy-consent" target="_blank" rel="noopener noreferrer">
            privacy policy
          </a>
          .
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Annulla</Button>
        <Button onClick={handleSave} variant="contained">
          Salva preferenze
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default CookiePreferencesModal
